import { createFileRoute } from "@tanstack/react-router";
import { InfoLayout } from "@/components/laneguide/InfoLayout";
import { Mail, Phone, MapPin } from "lucide-react";

export const Route = createFileRoute("/kontakt")({
  head: () => ({ meta: [{ title: "Kontakt | Svensk Låneguide" }, { name: "description", content: "Kontakta Svensk Låneguide. Vi svarar inom en arbetsdag." }] }),
  component: KontaktPage,
});

function KontaktPage() {
  return (
    <InfoLayout title="Kontakta oss">
      <p>Har du frågor? Skicka ett mejl till oss så hör vi av oss så snart vi kan.</p>
      <div className="rounded-lg border border-border bg-card p-6">
        <div className="space-y-3 text-sm text-foreground/80">
          <div className="flex items-center gap-2"><MapPin className="h-4 w-4 text-primary" /> Rexegatan 40, Kungälv</div>
          <div className="flex items-center gap-2"><Phone className="h-4 w-4 text-primary" /> 0721-63 23 36</div>
          <a
            href="mailto:svensklaneguide@outlook.com"
            className="flex items-center gap-2 font-semibold text-primary hover:underline"
          >
            <Mail className="h-4 w-4 text-primary" /> svensklaneguide@outlook.com
          </a>
        </div>
      </div>
    </InfoLayout>
  );
}
